<template>
  <vx-card title="Registration Type">
    <vue-apex-charts type="pie" :options="pieChart.chartOptions" :series="pieChart.series"/>
  </vx-card>
</template>

<script>
export default {
  name: 'registrations-type',
  props: {
    data: Object,
    program: String
  },
  watch: {
    data: {
      immediate: true,
      handler (value) {
        const root = value.analysis.find(n => n.name === 'ROOT');
        const allTime = root.nested.find(n => n.name === 'ALL_TIME');
        let source = allTime;
        if (this.program) {
          const programs = allTime.nested.find(n => n.name === 'PROGRAMS');
          source = programs.buckets.find(b => b.key === this.program);
        }
        const referralRegistered = source.nested.find(n => n.name === 'COUNT_REFERRAL') ? source.nested.find(n => n.name === 'COUNT_REFERRAL').value : 0;
        const totalRegistered = source.nested.find(n => n.name === 'COUNT').value;
        const selfRegistered = totalRegistered - referralRegistered;
        this.pieChart = {
          series: [selfRegistered, referralRegistered],
          chartOptions: {
            chart: {
              type: 'pie'
            },
            colors: this.colors,
            labels: ['SELF_REGISTERED', 'REFERRAL_REGISTERED'],
            dataLabels: {
              enabled: true,
              formatter (val) {
                return `${val.toFixed(1)} %`;
              }
            },
            legend: {
              show: false
            }
          }
        };
      }
    }
  }
};
</script>

<style scoped>

</style>
